/* eslint-disable max-lines */
import RelatedTestAux from '@/views/shared/related-test-aux/index.vue';
import AccountInfoAml from '@/views/accounts/accounts-details/account-info-aml/index.vue';


export default {
    name: 'AccountAux',
    components: { RelatedTestAux, AccountInfoAml },
    /**
     * @override
     */
    data() {
        return {
            accountTests: [],
            main_holder_info: {},
            isTestVisible: true,
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        },
        accountIntervenersRisk: {
            type: Array,
            required: false
        }
    },
    methods: {
        /**
         * Obtenemos la información del interviniente
         */
        fetchData() {
            this.uuid_account = this.uuid || this.$route.params.uuid;
            this.loadAccountTests(this.uuid_account);
        },
        
        getMainHolder(accountInterveners) {
            return accountInterveners.find(intervener =>
                intervener.account_intervener_role.some(role => ['TITULAR', 'NUDO_PROPIETARIO'].includes(role))
            );
        },

        async loadAccountTests(uuid) {
            const cfg = {};
            cfg.params = {};
            cfg.params.$expand = 'account_intervener_role';
            
            try {
                const res = await Promise.all([
                    this.$accountsService.getAccountTests(uuid, cfg),
                    this.$accountsService.getAccountInterveners(uuid, cfg)
                ]);
        
                // Obtener todos los tests
                const allTests = res[0].data.accounts_mifid.flatMap(account => account.tests || []);

                const latestTest = allTests.reduce((latest, current) => {
                    if (!latest.test_created_on || (new Date(current.test_created_on) > new Date(latest.test_created_on))) {
                        return current;
                    }
                    return latest;
                }, {});

                // Verificar si el test más reciente tiene respuestas y ordenarlas
                if (latestTest && latestTest.responses) {
                    latestTest.responses = latestTest.responses.sort((a, b) => a.order_question - b.order_question);
                }
        
                // Asignar las respuestas del test más reciente
                this.accountTests = latestTest ? [latestTest] : [];
                // Obtener la información de los interveners
                const accountInterveners = res[1].data.accounts_intervener;
                this.main_holder_info = this.getMainHolder(accountInterveners);
        
            } catch (error) {
                console.error('Error loading account tests:', error);
            }
        },

        getTableHeaders(answerObj) {
            if (!answerObj || typeof answerObj !== 'object') return [];
        
            const headers = [];
        
            // Iterar sobre cada clave y valor del objeto answerObj
            Object.entries(answerObj).forEach(([key, item]) => {
                headers.push({
                    key: key, 
                    label: item.response_text || key
                });
            });
            return headers;
        },
        
        getTableRows(answerObj) {
            if (!answerObj || typeof answerObj !== 'object') return [];
        
            const row = {}; // Crear un solo objeto para la fila única
        
            // Iterar sobre cada clave y valor del objeto answerObj
            Object.entries(answerObj).forEach(([key, item]) => {
                if (Array.isArray(item.value)) {
                    // Si 'value' es un array, concatenar 'response_text' con 'value'
                    row[key] = item.value
                        .map(subItem => subItem.value ? `${subItem.response_text} ${subItem.value}` : '') // Omitir valores vacíos
                        .filter(text => text) // Filtrar para eliminar entradas vacías
                        .join(', ');
                } else {
                    // Si 'value' es un objeto simple, agregar directamente el 'value' de ese objeto
                    row[key] = item.value || 'No aplica';
                }
            });
        
            return [row]; // Retornar un array con una sola fila
        }
    },
    beforeMount() {
        this.fetchData();
    }
};
